export function stringToArray(classes) {
    if (!classes) {
        return [];
    }

    if (Array.isArray(classes)) {
        return classes;
    }

    return classes.split(' ');
}
